import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DocumentModel } from 'src/app/models/document.model';
import { RequestModel } from 'src/app/models/requests';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { ChangeDetectorRef } from '@angular/core';
@Component({
  selector: 'app-performactiondocumentrendering',
  templateUrl: './performactiondocumentrendering.component.html'
})
export class PerformActionDocumentRenderingComponent implements OnInit {

  @Input('document') document!: DocumentModel;
  @Input('request') request!: RequestModel;
  translations: any = <any>{};

  constructor(private documentService: DocumentApiClient, private sanitizer: DomSanitizer, private translateService: TranslateService, private router: Router, private ref: ChangeDetectorRef) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  xbrlTemplate = 'assets/temp_html_pages/xbrl.html';
  xbrlTemp!: string;
  renderedDocument!: SafeHtml;
  getTranslations() {
    this.translateService.get([
      'Request.Rendered.ColumnTime',
      'Request.Rendered.ColumnStatusCode',
      'Request.Rendered.ColumnReference',
      'Request.Rendered.ColumnDescription',
    ]).subscribe(translation => {
      this.translations.columnTime = translation['Request.Rendered.ColumnTime'];
      this.translations.columnStatusCode = translation['Request.Rendered.ColumnStatusCode'];
      this.translations.columnReference = translation['Request.Rendered.ColumnReference'];
      this.translations.columnDescription = translation['Request.Rendered.ColumnDescription'];
    });
  }

  async ngOnInit(): Promise<void> {
    await this.renderHtml();
    this.ref.detectChanges()
    let tempFixInterval = setInterval(() => {
      this.fixHtml();
      clearInterval(tempFixInterval);
    }, 2000);
  }

  async renderHtml() {
    let anchorUrl: string = this.router.url;
    (await this.documentService.getRenderedHtml(this.request.id, this.document.id))
      .subscribe({
        error: (error: HttpErrorResponse) => console.error(error),
        next: (html: any) => {
          // html = html.replace("width: 21cm;", "width: 100%;")

          if (this.document.documentType === 'GenericTextFile') {
            html = html.replace('<font face="verdana">', "<style>table, #LogDigipoort table {width:100%; font-family: Lato, Arial;}\ntd {vertical-align: top; padding: 5px;}\ntbody tr:first-child td{font-weight: bold;}\ntd:nth-child(1){width: 180px;}\ntd:nth-child(2){width: 100px;}\ntd:nth-child(3){width: 220px;}\ntr:nth-child(even) {background: #f5f5f5;}\ntr:nth-child(odd) {background: #fff;}</style>")
              .replace("Tijdstip", "" + this.translations.columnTime + "")
              .replace("Statuscode", "" + this.translations.columnStatusCode + "")
              .replace("Kenmerk", "" + this.translations.columnReference + "")
              .replace("Omschrijving", "" + this.translations.columnDescription + "")
              .replace("<table>", "<table id='LogDigipoort'>")
              .replace('body {', '.page-container {')
              .replace('table {', '.page-container > table {')
          } else {
            html = html.replace(/#e07d48/g, "#0087FF")
              .replace(/#f58020/g, "#0087FF")
              .replace(/bisque/g, "#e0f1ff")
              .replace(/#3367e0/g, "#0087FF")
              .replace("</head>", "<style>table{width:100%;}\ntd {vertical-align: top;}\ntbody tr:first-child td{font-weight: bold !important;}\n.sbr-logo, .entrypoint, .logo, .menu-remaining{display:none}\n.display-none, menu-info.display-none{display:none}\n</style></head>")
              .replace('<font face="verdana">', "<style>table, #LogDigipoort table{width:100%; font-family: Lato, Arial;}\ntd {vertical-align: top;}\ntbody tr:first-child td{font-weight: bold;}\ntd:nth-child(1){width: 180px;}\ntd:nth-child(2){width: 100px;}\ntd:nth-child(3){width: 220px;}</style>")
              .replace('</font>', "")
              .replace('id="menu-info"', 'id="menu-info" class="display-none"')
              //Batavia
              .replace('width: 21cm;', "")
              .replace('min-height: 29.7cm;', "")
              .replace('padding: 2cm 2cm 2cm 2cm;', "padding: 20px; margin-bottom: 10px;")
              .replace('box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);', "box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.16);\nborder-radius: 3px;")
              .replace('.linebreak {  border:0; margin:0; height:10pt;  background:white; }', ".linebreak {  border:0; margin:0; }")
              .replace('pre { white-space:pre-wrap;   font-family: sans-serif, Arial; font-size:8pt; }', "pre { white-space:pre-wrap !important;   font-family: sans-serif, Arial !important; font-size:8pt !important; overflow: hidden !important; margin-bottom: 0 !important; }")
              .replace('box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);', "box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.16);")
              .replace('<table xmlns="http://www.w3.org/1999/xhtml">', '<table style="width:100%; table-layout:fixed; overflow-x:clip" xmlns="http://www.w3.org/1999/xhtml">')
              .replace('<table>', '<table style="width:100%; table-layout:fixed; overflow-x:clip">')
              .replace('<table>', '<table style="width:100%; table-layout:fixed; overflow-x:clip">')

              .replace('body {', '.page-container {')
              .replace('table {', '.page-container > table {')

            let re = /td colspan="7"/g;
            html = html.replace(re, 'td colspan="8"')
          }

          if (this.router.url.indexOf("#") > - 1)
            anchorUrl = this.router.url.split("#")[0];
          html = html.replace(/href=\"#/g, " href=\"" + anchorUrl + "#");
          this.renderedDocument = this.sanitizer.bypassSecurityTrustHtml(html);
        }
      });

  }
  async fixHtml() {
    let temp: HTMLElement = document.getElementById('renderDocumentElement' + this.document.id)!;
    // fix colspans Xbrl VatDeclaration
    if (this.request.dossierType === "VatDeclaration") {
      Array.from(temp.querySelectorAll('tr')).forEach(function (ele) {
        if (ele.querySelector('td')!.colSpan == 3) {
          ele.querySelector('td')!.colSpan = 7;
        } else if (ele.querySelector('td')!.colSpan == 4) {
          ele.querySelector('td')!.colSpan = 8;
        } else if (ele.querySelector('td')!.colSpan == 8) {
          ele.querySelector('td')!.colSpan = 12;
        }
      });
    }

    let count = 1;
    let y = this;
    Array.from(temp.querySelectorAll('.pageholder')).forEach(function (ele) {
      ele.id = y.document.id + "_" + count + "_indicator";
      count++;
    });

    let html = temp.innerHTML;
    this.renderedDocument = this.sanitizer.bypassSecurityTrustHtml(html);

  }
}
